import React from 'react';
const AvatarGroupContext = /*#__PURE__*/React.createContext(undefined);
export default AvatarGroupContext;
//# sourceMappingURL=AvatarGroupContext.js.map